/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  StatementHistoryItem,
  StatementSearchFilter,
  StatementSearchFilterTokenPagedRequest,
  StatementSearchResult,
  StatementSearchResultTokenPagedResult,
  StatementsSummary,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type postApiCcofPracticeIdStatementsSearchResponse200 = {
  data: StatementSearchResultTokenPagedResult;
  status: 200;
};

export type postApiCcofPracticeIdStatementsSearchResponse401 = {
  data: void;
  status: 401;
};

export type postApiCcofPracticeIdStatementsSearchResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdStatementsSearchResponseSuccess =
  postApiCcofPracticeIdStatementsSearchResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdStatementsSearchResponseError = (
  | postApiCcofPracticeIdStatementsSearchResponse401
  | postApiCcofPracticeIdStatementsSearchResponse403
) & {
  headers: Headers;
};

export const getPostApiCcofPracticeIdStatementsSearchUrl = (
  practiceId: string,
) => {
  return `/api/ccof/${practiceId}/statements/search`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Searches the practice's sent statements for the Patient AR table with per-column filtering and
cursor pagination. Filter criteria are in the request body (PHI must not appear in URLs/logs).
Results are strictly scoped to practiceId; statements of another practice are
never returned.
 */
export const postApiCcofPracticeIdStatementsSearch = async (
  practiceId: string,
  statementSearchFilterTokenPagedRequest?: StatementSearchFilterTokenPagedRequest,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<postApiCcofPracticeIdStatementsSearchResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return authenticatedClient<postApiCcofPracticeIdStatementsSearchResponseSuccess>(
    getPostApiCcofPracticeIdStatementsSearchUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(statementSearchFilterTokenPagedRequest),
    },
  );
};

export type getApiCcofPracticeIdStatementsStatementIdResponse200 = {
  data: StatementSearchResult;
  status: 200;
};

export type getApiCcofPracticeIdStatementsStatementIdResponse401 = {
  data: void;
  status: 401;
};

export type getApiCcofPracticeIdStatementsStatementIdResponse403 = {
  data: void;
  status: 403;
};

export type getApiCcofPracticeIdStatementsStatementIdResponse404 = {
  data: void;
  status: 404;
};

export type getApiCcofPracticeIdStatementsStatementIdResponseSuccess =
  getApiCcofPracticeIdStatementsStatementIdResponse200 & {
    headers: Headers;
  };
export type getApiCcofPracticeIdStatementsStatementIdResponseError = (
  | getApiCcofPracticeIdStatementsStatementIdResponse401
  | getApiCcofPracticeIdStatementsStatementIdResponse403
  | getApiCcofPracticeIdStatementsStatementIdResponse404
) & {
  headers: Headers;
};

export const getGetApiCcofPracticeIdStatementsStatementIdUrl = (
  practiceId: string,
  statementId: string,
) => {
  return `/api/ccof/${practiceId}/statements/${statementId}`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Returns a single statement's Patient AR row — the same fields (and card-status chip) as one row of the
search. The detail view loads its own row through this endpoint so it can re-fetch on a SignalR update,
rather than reusing the snapshot handed over from the list. Strictly scoped to
practiceId; a statement of another practice returns 404, not 403, so the endpoint
can't be used to probe whether another practice's statement exists.
 */
export const getApiCcofPracticeIdStatementsStatementId = async (
  practiceId: string,
  statementId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiCcofPracticeIdStatementsStatementIdResponseSuccess> => {
  return authenticatedClient<getApiCcofPracticeIdStatementsStatementIdResponseSuccess>(
    getGetApiCcofPracticeIdStatementsStatementIdUrl(practiceId, statementId),
    {
      ...options,
      method: "GET",
    },
  );
};

export type postApiCcofPracticeIdStatementsSummaryResponse200 = {
  data: StatementsSummary;
  status: 200;
};

export type postApiCcofPracticeIdStatementsSummaryResponse401 = {
  data: void;
  status: 401;
};

export type postApiCcofPracticeIdStatementsSummaryResponse403 = {
  data: void;
  status: 403;
};

export type postApiCcofPracticeIdStatementsSummaryResponseSuccess =
  postApiCcofPracticeIdStatementsSummaryResponse200 & {
    headers: Headers;
  };
export type postApiCcofPracticeIdStatementsSummaryResponseError = (
  | postApiCcofPracticeIdStatementsSummaryResponse401
  | postApiCcofPracticeIdStatementsSummaryResponse403
) & {
  headers: Headers;
};

export const getPostApiCcofPracticeIdStatementsSummaryUrl = (
  practiceId: string,
) => {
  return `/api/ccof/${practiceId}/statements/summary`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Returns the Collected / Scheduled / Remaining summary tiles for the Patient AR bar. Accepts the same
filter object as the search (in the request body, no paging) so the tiles always match the visible,
filtered table. Strictly scoped to practiceId; other practices contribute zero.
 */
export const postApiCcofPracticeIdStatementsSummary = async (
  practiceId: string,
  statementSearchFilter?: StatementSearchFilter,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<postApiCcofPracticeIdStatementsSummaryResponseSuccess> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return authenticatedClient<postApiCcofPracticeIdStatementsSummaryResponseSuccess>(
    getPostApiCcofPracticeIdStatementsSummaryUrl(practiceId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(statementSearchFilter),
    },
  );
};

export type getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse200 = {
  data: StatementHistoryItem[];
  status: 200;
};

export type getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse401 = {
  data: void;
  status: 401;
};

export type getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse403 = {
  data: void;
  status: 403;
};

export type getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse404 = {
  data: void;
  status: 404;
};

export type getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponseSuccess =
  getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse200 & {
    headers: Headers;
  };
export type getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponseError =
  (
    | getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse401
    | getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse403
    | getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponse404
  ) & {
    headers: Headers;
  };

export const getGetApiCcofPracticeIdPatientsPatientIdStatementHistoryUrl = (
  practiceId: string,
  patientId: string,
) => {
  return `/api/ccof/${practiceId}/patients/${patientId}/statement-history`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Returns the patient panel's Statement History: the patient's sent statements (newest-first),
each with its activity timeline — notification sends with per-medium SMS/EMAIL/PAPER state,
autocharge scheduled/failed events, payments, and projected future reminders.
 */
export const getApiCcofPracticeIdPatientsPatientIdStatementHistory = async (
  practiceId: string,
  patientId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponseSuccess> => {
  return authenticatedClient<getApiCcofPracticeIdPatientsPatientIdStatementHistoryResponseSuccess>(
    getGetApiCcofPracticeIdPatientsPatientIdStatementHistoryUrl(
      practiceId,
      patientId,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export type getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse200 =
  {
    data: void;
    status: 200;
  };

export type getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse401 =
  {
    data: void;
    status: 401;
  };

export type getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse403 =
  {
    data: void;
    status: 403;
  };

export type getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse404 =
  {
    data: void;
    status: 404;
  };

export type getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse502 =
  {
    data: void;
    status: 502;
  };

export type getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponseSuccess =
  getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse200 & {
    headers: Headers;
  };
export type getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponseError =
  (
    | getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse401
    | getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse403
    | getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse404
    | getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponse502
  ) & {
    headers: Headers;
  };

export const getGetApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfUrl =
  (practiceId: string, patientId: string, statementId: string) => {
    return `/api/ccof/${practiceId}/patients/${patientId}/statements/${statementId}/pdf`;
  };

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * Unlike the admin endpoint, a statement that belongs to another patient or another practice returns
 * 404, not 403 — on the clinic surface a 403/404 split would reveal whether another practice's
 * statement exists. A statement with no printable yet returns the same 404.
 * @summary Streams a statement's PDF for the client app's preview popup. The whole fetch (peripheral media
lookup, pooled download, filename) is reused from the admin-side endpoint added in CPAY-2138; this
action only adds the practice-scoped ownership gate.
 */
export const getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdf =
  async (
    practiceId: string,
    patientId: string,
    statementId: string,
    options?: Parameters<typeof authenticatedClient>[1],
  ): Promise<getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponseSuccess> => {
    return authenticatedClient<getApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfResponseSuccess>(
      getGetApiCcofPracticeIdPatientsPatientIdStatementsStatementIdPdfUrl(
        practiceId,
        patientId,
        statementId,
      ),
      {
        ...options,
        method: "GET",
      },
    );
  };
